<template>

<div class="selectp">
	<div class="select_bg"></div>
	<div class="select_p">
		<el-input  placeholder="请输入姓名" prefix-icon="el-icon-edit" v-model="username" class="select_input"/><span style="width:20px"></span>
		<el-button type="primary" icon="el-icon-search" class="select_button" @click="select">查询</el-button>
	</div><br>
	<div class="block" v-show="!show"></div>
	<div v-show="show">
		<div class="prize"  v-for="item in userinfo">
			<p></p>
			<div>作者姓名:<span  class="prize_s"></span>{{item.name}}</div>
			<div>所获奖项:<span class="prize_s"></span>{{item.prize}}</div>
			<div>获奖作品:<span class="prize_s"></span>{{item.worksname}}</div>
			<div>作品类型:<span class="prize_s"></span>{{item.workstype}}</div>
			<div>所在学校:<span class="prize_s"></span>{{item.school}}</div>
			<p></p>
		</div>
	</div>
	  <div class="banner-aaa"></div>
</div>


</template>

<script>
import "@/assets/base.css";
import "@/assets/xspx.css";

 export default {
    
    data() {
      return {
		  userinfo:[],
		  nickname : null,
		  username:null,
		  show:false,
      }
    },

    methods: {
		 _isMobile(){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },

	  select:function(){
		  var that = this;
		  var name = this.username 
		  if(name==null || name==""){
			  alert("请输入姓名")
		  } else {
			 //上线前记得吧vue.config中的target修改了 还有后台的WebMvcConfig修改了
			   that.$axios.get("http://xspxserver.zhyww.cn/xspxPrize/getPrize",//http://xspxserver.zhyww.cn/xspxGaojian/getGaojianList
                {params:{
                name:name,
                }})
              .then(function (response) {
				  console.log( response.data.xspxPrizes)
				  var state = response.data.state
				  if(state == "1"){
  					that.userinfo = response.data.xspxPrizes
				    that.show = true
				  } else {
					  alert("没有查到获奖信息")
				  }
				  
				
              }).catch(function (reason) {
                  alert("error");
              });
			
		  }
	  }
	},
	
	 mounted: function() {
    if (this._isMobile()) {
      
    
      this.$router.replace('/hjcxcgPhone');
    }else {
      //alert('pc端');
      //this.$router.replace('/hjcx');
    }
  },
    
  }
</script>
<style>
 .selectp{
   	width: 100%;
 }
 .block{
  width:100px;
  height: 100px;
  background:url('../assets/images/empty1.png');
  background-size:100% 100%;
  margin: 100px auto 0 auto;
 }
 .select_bg{
  height: 200px;
  background:url('../assets/images/qishi123.png');
  background-size:100% 100%;
	
}
 .select_p{
	 
	 text-align: center;
	 display: flex;
	 width:95%;
	 margin: 20px auto 0 auto;
 }
 .lip_top{
	
 }
 .prize{
	 margin-top: 30px;
	 margin-left: 2.5%;
	 width: 95%;
	 border-radius: 5px;
	 background-color: white;
	 
 }
 .prize div{
	 margin-left: 3%;
	 font-size: 14px;
	 margin-top: 5px;
 }
  .prize p{
	 height: 5px;
 }
 .prize_s{
	 margin-left: 3%;
 }
   .banner-aaa{
    height: 30px;
   
}
</style>